import React from 'react'
import { formatPercent } from '../../utils/tools'
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material'
import styles from './PercentageWithArrow.module.scss'

export default function PercentageWithArrow({number, makePrecent=true}) {

    const isPositive = number > 0

    return (
        <span className={`${styles['stock']} ${styles[isPositive ? "stockUp" : "stockDown" ]}`}>
            <span className={styles['arrow']}>{isPositive ?  <ArrowDropUp /> : <ArrowDropDown /> }</span>
            <span>{makePrecent ? formatPercent(number, 'never') : `${Math.abs(number)}%`}</span>
        </span>
    )
}